
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { adminStyles } from '../../Styles/adminStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Loader from 'react-loader-spinner'
import { ReactSVG } from 'react-svg';
import Images from '../../Theme/Images';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputAdornment from '@material-ui/core/InputAdornment';

@inject('adminStore', 'userStore')
@observer
class AddUser extends React.Component {
  state = {
    user: {
      email: "",
      userFullName: "",
      userType: "AGENT"
    },
    validationErrors: {},
    add: true,
  }
  handleChange = (event,field, value) => {
    const user = Object.assign({}, this.state.user, {
      [field]: value
    });
    this.setState({ user });
  }

  componentWillReceiveProps(nextprops) {
    if (nextprops.add)
      this.setState({ add: true, user: { userType: "AGENT" } })
    else
      this.setState({ add: false, user: nextprops.user })
  }

  save = (e) => {
    e.preventDefault();
    const { user, add } = this.state;
    let valid = false;
    valid = this.validateFields()
    if (valid) {
      if (add) {
        this.props.adminStore.createUser(this.state.user);
        this.setState({ user: { userType: 'AGENT' } })
      }

      else {
        let temp = {};
        temp.userFullName = user.userFullName;
        temp.userId = user._id;
        temp.userType = user.userType;
        temp.department = user.department;
        temp.domain = user.domain;
        temp.email = user.email
        this.props.adminStore.editUser(temp)
      }
      this.resetState()
    }
  }

  resetState = () => {
    this.setState({
      user: { userType: 'AGENT' },
      validationErrors: {},
    })
  }

  validateFields() {
    const { user, validationErrors } = this.state;
    const { adminStore } = this.props;
    var mob = /^[1-9]{1}[0-9]{9}$/;
    let valid = true;
    if (!adminStore.validateEmail(user.email)) {
      validationErrors['email'] = "Please enter a valid email address";
      this.setState({ validationErrors });
      valid = false;
    }
    else
      delete validationErrors['email']
    if (!user.userFullName || user.userFullName.length < 3 || user.userFullName.length > 40 || !user.userFullName.replace(/\s/g, '').length) {
      validationErrors['userFullName'] = "Name must contain a minimum of 3 and maximum of 40 characters ";
      this.setState({ validationErrors });
      valid = false;
    }
    else
      delete validationErrors['userFullName']
    if (!user.department || user.department.length < 3 || user.department.length > 40 || !user.department.replace(/\s/g, '').length) {
      validationErrors['department'] = "Department must contain a minimum of 3 characters ";
      this.setState({ validationErrors });
      valid = false;
    }
    else
      delete validationErrors['department']
    if (user.mobileNumber && user.mobileNumber.replace(/\s/g, '').length) {
      if (!user.mobileNumber || !mob.test(user.mobileNumber)) {
        validationErrors['mobileNumber'] = "Please enter a valid 10-digit mobile number!";
        this.setState({ validationErrors });
        valid = false;
      }
      else
        delete validationErrors['mobileNumber']
    }
    else
      delete validationErrors['mobileNumber']
    if (!user.domain || user.domain.length < 3 || user.domain.length > 40 || !user.domain.replace(/\s/g, '').length) {
      validationErrors['domain'] = "Domain must contain a minimum of 3 characters ";
      this.setState({ validationErrors });
      valid = false;
    }
    else
      delete validationErrors['domain']

    if (valid) {
      this.setState({
        validationErrors: {}
      });
    }
    return valid;
  }

  handleRadioChange = (event) => {
    const user = Object.assign({}, this.state.user, {
      userType: event.target.value
    });
    this.setState({ user });
  }

  cancel = (e) => {
    e.preventDefault()
    this.props.adminStore.openAddUserDialog(false);
    this.resetState()
  }

  resendEmail = (user) =>{
    this.props.adminStore.resendUpdateVerificationEmail(user)
  }

  render() {
    const { inProgress, addUserDialog } = this.props.adminStore;
    const { classes, theme } = this.props;
    const { user, validationErrors, add } = this.state;
    return (
      <Dialog BackdropProps={{
        classes: {
          root: classes.backdrop
        }
      }} disableBackdropClick={true} disableEscapeKeyDown={true} classes={{ paper: classes.dialog }} open={addUserDialog} onClose={this.closeDialog} aria-labelledby="form-dialog-title">
        <DialogTitle style={{ color: 'white' }}>
          <div style={{ textAlign: 'center' }}>
            <ReactSVG src={Images.profile} />
            <div>{add ? 'Add User' : 'Edit User'}</div>
          </div>
        </DialogTitle>
        <DialogContent>

          <form noValidate autoComplete="off" className={classes.formStyle}>
            <FormControl error aria-describedby="component-error-text" className={classes.formControl}>
              <TextField style={{ paddingTop: 0, marginTop: 0 }}
                required
                id="name-input"
                placeholder="Name*"
                type="text"
                name="name"
                autoComplete="name"
                margin="normal"
                variant="filled"
                fullWidth
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    input: classes.textFieldInput,
                  },
                }}
                value={user.userFullName}
                onChange={(event) => this.handleChange(event,"userFullName", event.target.value)}
              />
              {validationErrors.userFullName && <FormHelperText style={{ display: 'flex' }} id="name-input">
                <ReactSVG
                  beforeInjection={svg => {
                    svg.classList.add(classes.svg)
                  }}
                  src={Images.error} />{validationErrors.userFullName}</FormHelperText>}
              <TextField style={{ paddingTop: 0, marginTop: 0 }}
                required
                id="email-input"
                placeholder="Email*"
                type="email"
                name="email"
                autoComplete="email"
                margin="normal"
                variant="filled"
                fullWidth
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    input: classes.textFieldInput,
                  },
                  endAdornment: <InputAdornment position="end">
                    {!add && user.newEmail ? <ReactSVG src={Images.error} /> : null}
                  </InputAdornment>
                }}
                value={!add && user.newEmail ? user.newEmail : user.email}
                onChange={(event) => this.handleChange(event,"email", event.target.value)}
              />
              {validationErrors.email && <FormHelperText style={{ display: 'flex' }} id="email-error">
                <ReactSVG
                  beforeInjection={svg => {
                    svg.classList.add(classes.svg)
                  }}
                  src={Images.error} />
                {validationErrors.email}</FormHelperText>}

              <TextField style={{ paddingTop: 0, marginTop: 0 }}
                required
                id="mobileNo-input"
                placeholder="Mobile Number (Optional)"
                type="text"
                name="name"
                margin="normal"
                variant="filled"
                fullWidth
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    input: classes.textFieldInput,
                  },
                }}
                value={user.mobileNumber}
                onChange={(event) => this.handleChange(event,"mobileNumber", event.target.value)}
              />
              {validationErrors.mobileNumber && <FormHelperText style={{ display: 'flex' }} id="name-input">
                <ReactSVG
                  beforeInjection={svg => {
                    svg.classList.add(classes.svg)
                  }}
                  src={Images.error} />
                {validationErrors.mobileNumber}</FormHelperText>}
            </FormControl>
            <div className="rowFlex">
              <div style={{ marginRight: '1vw', width: '50%' }}>
                <TextField style={{ paddingTop: 0, marginTop: 0 }}
                  required
                  id="dept-input"
                  placeholder="Department*"
                  type="text"
                  name="dept"
                  autoComplete="dept"
                  margin="normal"
                  variant="filled"
                  fullWidth
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      input: classes.textFieldInput,
                    },
                  }}
                  value={user.department}
                  onChange={(event) => this.handleChange(event,"department", event.target.value)}
                />
                {validationErrors.department && <FormHelperText error={true} style={{ display: 'flex' }} id="department-input">
                  <ReactSVG
                    beforeInjection={svg => {
                      svg.classList.add(classes.svg)
                    }}
                    src={Images.error} />
                  {validationErrors.department}</FormHelperText>}

              </div>
              <div style={{ width: '50%' }}>
                <TextField style={{ paddingTop: 0, marginTop: 0 }}
                  required
                  id="domain-input"
                  placeholder="Domain*"
                  type="text"
                  name="domain"
                  autoComplete="domain"
                  margin="normal"
                  variant="filled"
                  fullWidth
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      input: classes.textFieldInput,
                    },
                  }}
                  value={user.domain}
                  onChange={(event) => this.handleChange(event,"domain", event.target.value)}
                />
                {validationErrors.domain && <FormHelperText error={true} style={{ display: 'flex' }} id="domain-input">
                  <ReactSVG
                    beforeInjection={svg => {
                      svg.classList.add(classes.svg)
                    }}
                    src={Images.error} />
                  {validationErrors.domain}</FormHelperText>}

              </div>
            </div>
            <div className={classes.medText}>Select Type</div>
            <RadioGroup className={classes.radioContainer} aria-label="gender" value={user.userType} name="userType" onChange={this.handleRadioChange}>
              <FormControlLabel value="AGENT" control={<Radio color="primary" classes={{ root: user.userType === "AGENT" ? classes.activeRadio : classes.radio }} />} label="Agent" />
              <FormControlLabel value="ADMIN" control={<Radio color="primary" classes={{ root: user.userType === "ADMIN" ? classes.activeRadio : classes.radio }} />} label="Admin" />
              {this.props.userStore.user.userType === 'SUPER_ADMIN' ?  <FormControlLabel value="SUPER_ADMIN" control={<Radio color="primary" classes={{ root: user.userType === "SUPER_ADMIN" ? classes.activeRadio : classes.radio }} />} label="Super Admin" />: null}
            </RadioGroup>
            {
              !add && user.newEmail ?
                <FormHelperText error={true} style={{ display: 'flex' }} id="domain-input">
                  <ReactSVG beforeInjection={svg => { svg.classList.add(classes.svg) }} src={Images.error} />
              Email Verification Pending. <span className={classes.resendMail} onClick={(e) => this.resendEmail(user)}> Resend mail</span> </FormHelperText>
                : null

            }
            <div className={classes.saveContainer}>
              <Button variant="contained" className={classes.button} onClick={this.cancel} > Cancel  </Button>
              {
                inProgress ?
                  <Button variant="contained" className={classes.button} style={{ backgroundColor: theme.palette.blue }}><Loader height={30} width={30} color={this.props.theme.palette.white} /></Button> :
                  <Button variant="contained" className={classes.button} style={{ backgroundColor: theme.palette.blue }} type="submit" onClick={this.save} > Save  </Button>

              }
            </div>
            }
          </form>
        </DialogContent>

      </Dialog>

    )
  }
}
export default withStyles(adminStyles, { withTheme: true })(withRouter(AddUser));
